// extracted by mini-css-extract-plugin
export default {"cgFormControl":"form-control-module-cgFormControl--lKKDb"};